import { Component, Input, OnInit } from "@angular/core";
import { Model } from "survey-core";
@Component({
  selector: "app-surveyjs-form",
  templateUrl: "./surveyjs-form.component.html",
  styleUrls: ["./surveyjs-form.component.scss"],
})
export class SurveyjsFormComponent implements OnInit {
  surveyModel: Model | undefined;
  @Input() survey: any;

  ngOnInit() {
    const survey = new Model(this.survey.pages[0]);
    this.surveyModel = survey;
  }
}
